import { e4Format, e4Formats } from 'helpers/dates';
import { StringHelpers } from 'e4shared';

export const courseTitle = c => {
    let title = c.name;
    if (c.disabled) title = `${title}\nLOCKED`;
    if (!c.disabled && !c.test) title = `${title}\n${c.progress.toFixed(0)}% Complete`;
    if (!c.disabled && c.test && c.passed) title = `${title}\nPassed - ${c.mark[c.mark.length - 1]}%`;
    if (!c.disabled && c.completed) title = `${title}\nCompleted - ${e4Format(c.completed)}`;
    if (!c.disabled && c.test && !c.passed)
        title = `${title}\nNot yet passed - ${c.mark ? c.mark.length : 0} ${StringHelpers.pluralise(
            'attempt',
            c.mark ? c.mark.length : 0
        )}`;
    return title;
};

export const taskTitle = t => {
    let title = t.name;
    let extra = '';
    if (t.mandatory) title = `${title}\nMANDATORY`;
    if (t.due) title = `${title}\nDue: ${e4Format(t.due)}`;
    if (t.date_Completed) title = `${title}\nCompleted: ${e4Format(t.date_Completed)}`;
    if (t.metric_Task && t.date_Completed && t.goal_Met) extra = ' - Completed';
    if (t.metric_Task && t.date_Completed && !t.goal_Met) extra = ' - Not Completed';
    if (t.requires_Manager && t.approved) title = `${title}\nApproved${extra}`;
    if (t.requires_Manager && t.date_Completed && !t.approved) title = `${title}\nAwaiting approval`;
    return title;
};

export const courseClass = c => {
    if (c.disabled) return 'text-disabled';
    if (c.progress === 100 || c.passed) return 'text-green';
    if (c.progress > 0) return 'text-orange';
    if (c.progress === 0) return 'text-red';
    return 'text-disabled';
};

export const taskClass = (c, t) => {
    let result = '';
    if (!result && c.progress !== 100) result = 'text-disabled';
    if (!result && !t.date_Completed) result = 'text-red';
    if (!result && t.date_Completed && t.waiting_Approval) result = 'text-orange';
    if (!result && t.date_Completed) result = 'text-green';

    return result || 'text-disabled';
};
